import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-31">
      <button onClick={onClick} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-32">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-viridia-600' : 'text-gray-900 group-hover:text-viridia-600'}`} data-id="element-33">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-viridia-600' : ''}`} data-id="element-34" />
      </button>
      <AnimatePresence data-id="element-35">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-36">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-37">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Does this replace my office staff?',
    answer: "Not necessarily. Jessica is designed to catch missed and after-hours calls your team can't get to. She supports your existing staff by handling the overflow so no lead slips through."
  }, {
    question: "What if I'm not tech-savvy?",
    answer: 'No problem. Viridia Analytics handles the entire setup, scripting, and integration for you. You just answer the Strategy Call and go live.'
  }, {
    question: 'Can I cancel anytime?',
    answer: "Yes. Jessica is month-to-month with no long-term contracts. If she's not generating more than $697/month in recovered revenue for you, you should not stay."
  }, {
    question: 'Can Jessica support multiple locations or phone numbers?',
    answer: 'Absolutely. We can configure flexible routing rules for multiple locations, departments, or phone lines based on your needs.'
  }, {
    question: 'How long does setup take?',
    answer: 'Most businesses go live within 3–7 business days after their Strategy Call with Kevin.'
  }];
  return <section className="py-20 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="text-center mb-12" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-41">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600" data-id="element-42">
            Everything you need to know about getting started.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8" data-id="element-43">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-44" />)}
        </div>
      </div>
    </section>;
}